/*
 * Digital Purchase Order
 *
 * Copyright (c) 2018 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow

import 'script-loader!./node_modules/jquery/dist/jquery.min.js'
import 'script-loader!./node_modules/jquery-migrate/dist/jquery-migrate.js'
import 'script-loader!./node_modules/jsviews/jsviews.min.js'
import 'script-loader!./node_modules/jquery-ui/dist/jquery-ui.min'
import 'script-loader!./node_modules/jquery-validation/dist/jquery.validate.min.js'
import 'script-loader!./node_modules/jquery-validation/dist/additional-methods.min.js'

import 'script-loader!././jquery.i18n.js'
import 'script-loader!./library/ppplus.min.js'

import 'script-loader!./library/bootstrap.min'
import 'script-loader!././include/Legacy.js'

import './include/jsviews.extend'

import { PasswordValidator } from "./include/PasswordValidator";

$(document).ready(function() {
  var payment_data = {
    approval_url: "",
    payment_method:"",
    pp_mode:""
  };
  if (document.location.pathname.indexOf("order.php") !== -1) {
    try {
      payment_data = JSON.parse($("#payment_data").text());
    } catch (e) {}

    if (payment_data.payment_method == 'ppp') {

      var loaded = false;

      window.nonce = payment_data.n;

      var ppp = PAYPAL.apps.PPP({
        "approvalUrl": payment_data.approval_url,
        "placeholder": "ppp-wrap",
        "mode": payment_data.pp_mode,
        "country": "DE",
        "buttonLocation": "outside",
        "showPuiOnSandbox": false,
        "showLoadingIndicator": true,
        "onLoad": function () {
          loaded = true;
          $("[name=purchase]").attr("disabled", false);
          $("#long-loading-message").hide();
        }
      });

      setTimeout(
          function () {
            if (!loaded) {
              $("#long-loading-message").show();
            }
          },
          10000
      );
    }

    $('.submit.ppp').on('click', (e) => {
        e.preventDefault();
        PAYPAL.apps.PPP.doCheckout();
    });
  }
});

$(document).ready(function() {
  if (document.location.pathname == "/billing.php") {

    //something else from billing.tpl
    var changePasswordField = function(element, type) {
      var newElem = element.clone();
      newElem.attr('type', type);
      newElem.insertBefore(element);
      element.remove();
    }

    $('#website-billing-account-password').keyup(function() {
      //$('#website-billing-account-password-too-weak').animate({ opacity: 0, height:0 }, 500, 'swing', function() { $(this).remove(); });
      $('#website-billing-account-password-too-weak').slideUp();
    });

    $('.show-password').on('mousedown', function() {
      changePasswordField($(this).siblings('input'), 'text');
    });

    $('.show-password').on('mouseup', function() {
      changePasswordField($(this).siblings('input'), 'password');
    });

    $('#website-billing-account-email').keyup(function() {

      var checkedAccount = $(this).data('checked-account');


      if (checkedAccount && (checkedAccount == $(this).val())) {
        $("#website-billing-account-already-exists").animate({
          opacity: 1
        },500);
      } else {
        $("#website-billing-account-already-exists").animate({
          opacity: 0.1
        },500);

      }
    });

    $('#website-billing').find('form').validate({
      errorPlacement: function(element) {

      },
      highlight: function(element) {
        $(element).closest('.form-group').addClass('has-error');
      },
      unhighlight: function(element) {
        $(element).closest('.form-group').removeClass('has-error');
      },
      rules: {
        payment: 'required',
        'account[emailverify]': {
          equalTo: '#website-billing-account-email'
        },
      }
    });

    $('#website-billing').find('.payment').find('input + img, input + label').on('click', function() {
      $('#website-billing').find('.submit').text($(this).prev().data('button'));
    });
    $('#website-billing').find('.payment').find('input').on('click', function() {
      $('#website-billing').find('.submit').text($(this).data('button'));
    });

    $('#website-billing').find('.submit').text($('#website-billing').find('.payment').find('input:checked').data('button'));

    //and yet one block
    $("#continueButton").on('click', function() {
      $("#website-billing").trigger('click');
      console.log("asd");
    });

    var policy_json = {
      Length: 6,
      Digits: 1,
      UpperCase: 1,
      LowerCase: 1,
      SpecialChars: 1,
      RepetitiveChars: 0
    };

    try {
      policy_json = JSON.parse($("#password-policy-json").text());
    } catch (e) {
    }

    var passwordValidator = new PasswordValidator($('form input[type=password]'), {
      Policy: policy_json,
      Fields: {
        EMail: 'input[type=email]',
        FirstName: 'input[name="account[firstname]"]',
        LastName: 'input[name="account[lastname]"]',
        PolicyDescription: $("#password-policy-wrap")
      }
    });

    var renderPasswordErrors = function (errors) {
      var error_list = $('input[type=password] + ul.error-list');
      error_list.html('');
      if (errors instanceof Array && errors.length) {
        errors.forEach(function (e) {
          error_list.append('<li>' + e + '</li>');
        });
      }
    }

    var onValidationResponse = function (response_obj) {
      if (response_obj.hasOwnProperty('Errors')) {
        renderPasswordErrors(response_obj.Errors);
      }
    }

    passwordValidator.registerResponseCB(onValidationResponse);

    var getPasswordField = function () {
      var password_policy = $('.password-policy');
      return {
        Length: password_policy.find('.length'),
        LowerCase: password_policy.find('.lower'),
        UpperCase: password_policy.find('.upper'),
        SpecialChars: password_policy.find('.special'),
        Digits: password_policy.find('.digits')
      }
    }

    $('form').on('keyup', 'input[type=password]', function () {
      var result = passwordValidator.getRulesResult($(this).val()),
          elements = getPasswordField();

      for (var key in elements) {
        if (elements.hasOwnProperty(key)) {
          if (result.Tests[key]) {
            elements[key].removeClass('not-passing');
            elements[key].addClass('passing');
          } else {
            elements[key].addClass('not-passing');
            elements[key].removeClass('passing');
          }
        }
      }

    });
  }
});

$(document).ready(function() {
  if (document.location.pathname == "/completed.php") {

    function showYouTubeVideo(id, vidtitle) {

      var video = $('<object id="promo-video" class="youtube-video" width="853" height="480"><param name="movie" value="https://www.youtube-nocookie.com/v/' + id + '?version=3&amp;hl=de_DE&amp;rel=0"></param><param name="allowFullScreen" value="true"></param><param name="allowscriptaccess" value="always"></param><embed src="https://www.youtube-nocookie.com/v/' + id + '?version=3&amp;hl=de_DE&amp;rel=0" type="application/x-shockwave-flash" width="853" height="480" allowscriptaccess="always" allowfullscreen="true"></embed></object>');

      video.dialog({
        modal: true,
        width: 853,
        height: 480,
        resizable: false,
        title: vidtitle,
        close: function () {
          video.remove();
        }
      });
    }

    $(document).ready(function () {
          $('.website-tutorials .tutorial').on('click', function () {
                var videoID = $(this).attr('data-youtube-id');
                var videoTitle = $(this).attr('data-title');

                showYouTubeVideo(videoID, videoTitle);
              }
          );
        }
    );
  }
});

jQuery.htmlPrefilter = function( html ) {
    return html;
};